import axios from "axios";
import buildUrl from "build-url-ts";

const apiV2 = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/2.0`;

export type BrandKitMediaType = "image" | "video";

export interface PaletteItem {
  id: string;
  type: string;
  [key: string]: unknown;
}

export interface BrandKitMediaItem {
  id: string;
  name: string;
  url: string;
  type: string;
  contentType: string;
  width: number;
  height: number;
  [key: string]: unknown;
}

export interface BrandKitMediaPage {
  records: BrandKitMediaItem[];
  currentPage: number;
  totalPages: number;
  recordsPerPage: number;
  totalRecordsCount: number;
}

export interface FetchBrandKitMediaParams {
  paletteId: string;
  mediaType: BrandKitMediaType;
  page: number;
  limit?: number;
  sort?: string;
  order?: string;
}

export interface FetchMyUploadsParams {
  mediaType: BrandKitMediaType;
  page: number;
  limit?: number;
  sort?: string;
  order?: string;
  query?: string;
  storyboard?: string;
}

export const brandKitMediaApi = {
  // GET /api/2.0/palette — returns list of palettes for the workspace.
  // The one with type === 'MEDIA' holds the brandkit palette id.
  fetchPalettes: async (): Promise<PaletteItem[]> => {
    const url = buildUrl(`${apiV2}/palette`);
    const response = await axios.get(url);
    return response.data;
  },

  // Brand kit palette media: POST /api/2.0/media/search with palette filter
  fetchBrandKitMedia: async (params: FetchBrandKitMediaParams): Promise<BrandKitMediaPage> => {
    const url = buildUrl(`${apiV2}/media/search`);
    const response = await axios.post(url, {
      palette: params.paletteId,
      mediaTypes: [params.mediaType],
      page: params.page,
      limit: params.limit ?? 20,
      sort: params.sort ?? "modifiedDate",
      order: params.order ?? "desc",
    });
    return response.data;
  },

  deleteMedia: async (mediaId: string): Promise<void> => {
    const url = buildUrl(`${apiV2}/media/${mediaId}`);
    await axios.delete(url);
  },

  // My Uploads: POST /api/2.0/media/search — user's own uploaded media (no palette filter)
  fetchMyUploads: async (params: FetchMyUploadsParams): Promise<BrandKitMediaPage> => {
    const url = buildUrl(`${apiV2}/media/search`);
    const body: Record<string, unknown> = {
      storyboard: params.storyboard,
      mediaTypes: [params.mediaType],
      page: params.page,
      limit: params.limit ?? 20,
      sort: params.sort ?? "modifiedDate",
      order: params.order ?? "desc",
    };
    if (params.query) body.query = params.query;
    const response = await axios.post(url, body);
    return response.data;
  },
};
